import { useSearchParams } from 'react-router-dom';

import { ia } from 'lib/helpers/utility';
import { useTableContext } from 'lib/context/TableContext/TableContext';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';
import { getActiveFilters } from 'components/shared/Filters/lib/helpers';
import EmptyDataRows from 'components/shared/AgTablePage/components/EmptyDataRows';

const EmptyProviderState = ({ addProvider, addProviderButton, title, description }) => {
  const { filters, updateFilters } = useTableContext();
  const [_, setSearchParams] = useSearchParams();

  const hasActiveFilters = ia(getActiveFilters(filters));

  if (hasActiveFilters) {
    return (
      <div className="flex flex-col items-center gap-1 px-4 py-10">
        <Icon icon="illustration-empty-table" />

        <Typography weight={600} size="base" className="text-primary-900">
          No results match your filters
        </Typography>

        <Typography weight={400} size="small" color="neutral-600">
          Adjust the filters to see more results.
        </Typography>

        <Button
          text="Clear filters"
          icon="close-square-mono"
          variant="link"
          size="xs"
          onClick={() => {
            setSearchParams({});
            updateFilters(null);
          }}
        />
      </div>
    );
  }

  const finalTitle = addProvider ? 'All providers have already been added' : title;
  const finalDescription = addProvider
    ? 'There are no more providers available to add. All practice providers are already in this list.'
    : description;

  return (
    <EmptyDataRows
      title={finalTitle}
      description={finalDescription}
      buttonComponent={addProviderButton}
      isButton={!addProvider}
    />
  );
};

export default EmptyProviderState;
